import React, { useEffect, useState } from 'react';
import axios from 'axios';
import './addProduct.css';

const categories = ['Face', 'Hair', 'Body'];
const types = ['soap', 'face', 'oil', 'shampoo', 'body'];
const bodyTypesList = [
  'All Skin Types', 'Acne', 'Dry Skin', 'Oily Skin', 'Hair Fall', 'Dull Skin',
  'Sensitive Skin', 'Uneven Tone', 'Tanning Remover', 'Glowing Skin', 'Acne-Prone Skin'
];

const AddProduct = ({ editdata, onCancel }) => {
  const [formData, setFormData] = useState({
    name: '',
    description: '',
    price: '',
    offerPrice: '',
    category: '',
    type: '',
    bodyTypes: [],
    image: null
  });
  const [editFlag, setEditFlag] = useState(false);
  const handleChange = e => {
    const { name, value, type, checked, files } = e.target;

    if (type === 'file') {
      setFormData(prev => ({ ...prev, image: files[0] }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleBodyTypeChange = e => {
    const { value, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      bodyTypes: checked
        ? [...prev.bodyTypes, value]
        : prev.bodyTypes.filter(bt => bt !== value)
    }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const data = new FormData();
    Object.entries(formData).forEach(([key, val]) => {
      if (key === 'image' && !val) return; // Skip null image
      if (Array.isArray(val)) {
        val.forEach(v => data.append(key, v));
      } else {
        data.append(key, val);
      }
    });


    try {
      if (editFlag) {

        // Edit Mode
        const response = await axios.put(
          `https://swarna-herbal-backend.onrender.com/api/products/${editdata._id}`,
          data
        );
        if (response.status === 200) {
          alert('Product updated successfully!');
        } else {
          alert('Failed to update product');
        }
      } else {
        // Add Mode
        const response = await axios.post(
          'https://swarna-herbal-backend.onrender.com/api/products',
          data
        );
        if (response.status === 200 || response.status === 201) {
          alert('Product added successfully!');
        } else {
          alert('Failed to add product');
        }
      }

      setFormData({
        name: '',
        description: '',
        price: '',
        offerPrice: '',
        category: '',
        type: '',
        bodyTypes: [],

        image: null
      });

      if (onCancel) onCancel(); // Optional: close form or signal parent

    } catch (err) {
      console.error(err);
      alert('Error submitting product');
    }
  };

  useEffect(() => {
    if (editdata) {
      setFormData({
        ...editdata,
        bodyTypes: Array.isArray(editdata.bodyTypes) ? editdata.bodyTypes : [],
        image: null
      });
      setEditFlag(true);
    } else {
      setEditFlag(false);
    }

  }, [editdata]);


  return (
    <div className="add-product-container">
      <h2>{editFlag ? 'Edit Product' : 'Add New Product'}</h2>
      <form onSubmit={handleSubmit} className="add-product-form">
        <input value={formData.name} type="text" name="name" placeholder="Product Name" onChange={handleChange} required />
        <textarea value={formData.description} name="description" placeholder="Description" onChange={handleChange} required />
        <input value={formData.price} type="number" name="price" placeholder="Price" onChange={handleChange} required />
        <input value={formData.offerPrice} type="number" name="offerPrice" placeholder="Offer Price" onChange={handleChange} required />

        <label>Category:</label>
        <select name="category" onChange={handleChange} value={formData.category} required>
          <option value="">Select Category</option>
          {categories.map(cat => (
            <option key={cat} value={cat}>{cat}</option>
          ))}
        </select>

        <label>Type:</label>
        <select name="type" onChange={handleChange} value={formData.type} required>
          <option value="">Select Type</option>
          {types.map(t => (
            <option key={t} value={t}>{t}</option>
          ))}
        </select>

        <label>Body Types:</label>
        <div className="checkbox-dropdown">
          {bodyTypesList.map(bt => (
            <label key={bt} className="checkbox-option">
              <input
                type="checkbox"
                value={bt}
                checked={formData.bodyTypes.includes(bt)}
                onChange={handleBodyTypeChange}
              />
              {bt}
            </label>
          ))}
        </div>



        <input type="file" name="image" accept="image/*" onChange={handleChange} required={!editFlag} disabled={editFlag} />

        <div className="form-buttons">
          <button type="submit">{editFlag ? 'Update Product' : 'Add Product'}</button>
          {editFlag && onCancel && (
            <button type="button" onClick={onCancel}>Cancel</button>
          )}
        </div>
      </form>
    </div>
  );
};

export default AddProduct;
